"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSlide = setSlide;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var actionSetSlideSuccess = function actionSetSlideSuccess(slide) {
  return {
    payload: slide,
    type: 'SET_SLIDE_SUCCESS'
  };
};

var actionSetSlideInProcess = function actionSetSlideInProcess() {
  return {
    type: 'SET_SLIDE_IN_PROCESS'
  };
};

var actionSetSlideFailed = function actionSetSlideFailed() {
  return {
    type: 'SET_SLIDE_FAILED'
  };
};

function setSlide(slideNumber) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
        var slideApi, _ref3, data, errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                slideApi = _ref.slideApi;
                dispatch(actionSetSlideInProcess());
                _context.next = 4;
                return slideApi.selectSlide(slideNumber);

              case 4:
                _ref3 = _context.sent;
                data = _ref3.data;
                errors = _ref3.errors;

                if (errors) {
                  _context.next = 12;
                  break;
                }

                dispatch(actionSetSlideSuccess(data));
                return _context.abrupt("return", data);

              case 12:
                dispatch(actionSetSlideFailed());
                return _context.abrupt("return", errors);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}